<template>
  <div id="fullWareReceupt">
    <!-- PC端 -->
    <div
      class="warehouse_PC"
      v-if="deviceType == 'tablet' || deviceType == 'desktop'"
    >
      <div class="warehouse_PC_con">
        <!-- 表单标题 -->
        <div class="warehouse_PC_head">整柜-入库单</div>
        <!-- 警示 -->
        <div class="warehosue_PC_warning">
          <div class="warehouse_warning_chose">
            语言/language: &nbsp;&nbsp;&nbsp;&nbsp;<el-button
              @click="changeLang('CN')"
              :type="languageType == 'CN' ? 'primary' : 'default'"
              >中文</el-button
            >
            <el-button
              @click="changeLang('EN')"
              :type="languageType == 'EN' ? 'primary' : 'default'"
              >English</el-button
            >
          </div>
          <div class="warehouse_warn_words">
            注意:&nbsp;&nbsp;请务必认真填写货值并提交确认,此信息具有法律效应!
          </div>
        </div>
        <!-- 入仓单 -->
        <div class="warehouse_in_order">
          <!-- <div class="warehouse_order_choices">
      <div class="warehouse_choices_title">入仓单序号(点击查看详情)</div>
      <ul class="warehouse_choices_ul">
       <li :class="{warehosue_choices_li:true,active_preview:previewIndex==index}" @click="changePreviewIndex(index)"
        v-for="(item,index) in inOrderList" :key="index">{{index+1}}</li>
      </ul>
     </div> -->
          <div class="warehouse_orders">
            <div class="warehouse_orders_item">
              <div class="warehouse_item_title">
                <div
                  style="
                    display: flex;
                    flex: 1;
                    flex-direction: row;
                    align-items: center;
                  "
                >
                  客户简称:&nbsp;&nbsp;&nbsp;{{ customer }}
                </div>
                <!-- <div class="warehouse_value_input">
         <div class="warehouse_value_title">货值金额(USD):</div>
         <el-input></el-input>
        </div> -->
              </div>
              <div class="warehouse_orders_con">
                <!-- 1 -->
                <div class="warehouse_con_son">单号</div>
                <!-- 2 -->
                <div class="warehouse_con_son">
                  {{
                    languageType == "EN" ? submitForm.nos.en : submitForm.nos.cn
                  }}
                </div>
                <!-- 3 -->
                <div class="warehouse_con_son">起运港</div>
                <!-- 4 -->
                <div class="warehouse_con_son">
                  {{
                    languageType == "EN"
                      ? submitForm.departureEnPort.en
                      : submitForm.departureEnPort.cn
                  }}
                </div>
                <!-- 5 -->
                <div class="warehouse_con_son">目的港</div>
                <!-- 6 -->
                <div class="warehouse_con_son">
                  {{
                    languageType == "EN"
                      ? submitForm.destinationEnPort.en
                      : submitForm.destinationEnPort.cn
                  }}
                </div>
                <!-- 7 -->
                <div class="warehouse_con_son">件数</div>
                <!-- 8 -->
                <div class="warehouse_con_son">
                  {{
                    languageType == "EN"
                      ? submitForm.piece.en
                      : submitForm.piece.cn
                  }}
                </div>
                <!-- 9 -->
                <div class="warehouse_con_son">柜号</div>
                <!-- 10 -->
                <div
                  class="warehouse_con_son"
                  style="display: flex; flex-direction: row; gap: 10px"
                >
                  {{
                    languageType == "EN"
                      ? submitForm.cntNo.en
                      : submitForm.cntNo.cn
                  }}
                  <el-input
                    v-if="submitForm.isConfirm.en != 1"
                    v-model="confirmWords[0]"
                    @input="handleInput(confirmWords[0], 0)"
                    class="input_num"
                  ></el-input>
                  <el-input
                    v-if="submitForm.isConfirm.en != 1"
                    v-model="confirmWords[1]"
                    @input="handleInput(confirmWords[1], 1)"
                    class="input_num"
                  ></el-input>
                  <el-input
                    v-if="submitForm.isConfirm.en != 1"
                    v-model="confirmWords[2]"
                    @input="handleInput(confirmWords[2], 2)"
                    class="input_num"
                  ></el-input>
                  <el-input
                    v-if="submitForm.isConfirm.en != 1"
                    v-model="confirmWords[3]"
                    @input="handleInput(confirmWords[3], 3)"
                    class="input_num"
                  ></el-input>
                </div>
                <!-- 11 -->
                <div class="warehouse_con_son" style="color: rgb(224, 0, 17)">
                  货值(USD)
                </div>
                <!-- 12 -->
                <div class="warehouse_con_son">
                  <!-- {{languageType=='EN'?submitForm.goodsValue.en:submitForm.goodsValue.cn}} -->
                  <el-input
                    clearable
                    type="number"
                    v-model="submitForm.goodsValue.en"
                    @input="handleUsdInput(submitForm.goodsValue.en)"
                    placeholder="请填写货值金额"
                  ></el-input>
                </div>
                <!-- 13 -->
                <div class="warehouse_con_son" style="color: rgb(224, 0, 17)">
                  提交人
                </div>
                <!-- 14 -->
                <div class="warehouse_con_son">
                  <!-- {{languageType=='EN'?submitForm.commit.en:submitForm.commit.cn}} -->
                  <el-input
                    v-model="submitForm.commit.en"
                    @input="handleSonInput(submitForm.commit.en)"
                    placeholder="请填写提交人"
                  ></el-input>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 底部提交栏 -->
        <div class="warehouse_PC_bottom" v-if="submitForm.isConfirm.en != 1">
          <!-- <div class="warehouse_bottom_first">
      <div style="color:rgb(224, 0, 17) ;">提交人:</div>
      <el-input></el-input>
     </div> -->
          <div class="warehouse_bottom_second">
            <el-button @click="submitFormVal(false)">保存</el-button>
            <el-button @click="submitFormVal(true)">确认并提交</el-button>
          </div>
        </div>
      </div>
    </div>
    <!-- 移动端 -->
    <div class="warehouse_Mobile" v-if="deviceType == 'mobile'">
      <div class="warehouse_Mobile_title">入库单确认</div>
      <div class="warehouse_Mobile_warning">
        <i class="el-icon-warning" style="color: #ee3330"></i>
        注意:请务必认真填写货值并提交确认,此信息具有法律效应!
      </div>
      <div class="warehouse_Mobile_con">
        <div class="warehouse_Mobile_lang">
          语言(Language):
          <div
            @click="changeLang('CN')"
            :class="{
              Mobile_chose_btn: true,
              Mobile_btn_active: languageType == 'CN'
            }"
          >
            中文
          </div>
          <div
            @click="changeLang('EN')"
            :class="{
              Mobile_chose_btn: true,
              Mobile_btn_active: languageType == 'EN'
            }"
          >
            English
          </div>
        </div>
        <!-- 客户入库单 -->
        <div class="warehouse_inOrder_list">
          <ul class="warehouse_inOrder_ul">
            <li class="warehouse_inOrder_li">
              <div class="inOrder_li_cus">客户:{{ customer }}</div>
              <!-- <div class="inOrder_li_money">
        <div>货值金额</div>
        <div><el-input placeholder="请填写货值金额">
          <template slot="append">USD</template>
         </el-input></div>
       </div> -->
              <div class="inOrder_li_form">
                <div>
                  <div>单号</div>
                  <div>
                    {{
                      languageType == "EN"
                        ? submitForm.nos.en
                        : submitForm.nos.cn
                    }}
                  </div>
                </div>
                <div>
                  <div>起运港</div>
                  <div>
                    {{
                      languageType == "EN"
                        ? submitForm.departureEnPort.en
                        : submitForm.departureEnPort.cn
                    }}
                  </div>
                </div>
                <div>
                  <div>目的港</div>
                  <div>
                    {{
                      languageType == "EN"
                        ? submitForm.destinationEnPort.en
                        : submitForm.destinationEnPort.cn
                    }}
                  </div>
                </div>
                <div>
                  <div>件数</div>
                  <div>
                    {{
                      languageType == "EN"
                        ? submitForm.piece.en
                        : submitForm.piece.cn
                    }}
                  </div>
                </div>
                <div>
                  <div>柜号</div>
                  <div
                    class="boxNum"
                    style="display: flex; flex-direction: row; gap: 10px"
                  >
                    {{
                      languageType == "EN"
                        ? submitForm.cntNo.en
                        : submitForm.cntNo.cn
                    }}
                    <el-input
                      v-if="submitForm.isConfirm.en != 1"
                      v-model="confirmWords[0]"
                      @input="handleInput(confirmWords[0], 0)"
                      class="input_num"
                    ></el-input>
                    <el-input
                      v-if="submitForm.isConfirm.en != 1"
                      v-model="confirmWords[1]"
                      @input="handleInput(confirmWords[1], 1)"
                      class="input_num"
                    ></el-input>
                    <el-input
                      v-if="submitForm.isConfirm.en != 1"
                      v-model="confirmWords[2]"
                      @input="handleInput(confirmWords[2], 2)"
                      class="input_num"
                    ></el-input>
                    <el-input
                      v-if="submitForm.isConfirm.en != 1"
                      v-model="confirmWords[3]"
                      @input="handleInput(confirmWords[3], 3)"
                      class="input_num"
                    ></el-input>
                  </div>
                </div>
                <div>
                  <div>货值金额</div>
                  <div>
                    <el-input
                      class="mobile_money"
                      clearable
                      type="number"
                      v-model="submitForm.goodsValue.en"
                      @input="handleUsdInput(submitForm.goodsValue.en)"
                      placeholder="请填写货值金额"
                    >
                      <template slot="append">USD</template></el-input
                    >
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <!-- 底部提交人 -->
        <div
          class="mobile_submit_bottom"
          :style="{ height: submitForm.isConfirm.en != 1 ? '120px' : '50px' }"
        >
          <div class="mobile_submit_man">
            <div class="mobile_submit_contact">提交人</div>
            <el-input
              v-model="submitForm.commit.en"
              @input="handleSonInput(submitForm.commit.en)"
              placeholder="请填写提交人"
            ></el-input>
          </div>
          <div class="mobile_submit_btns" v-if="submitForm.isConfirm.en != 1">
            <el-button @click="submitFormVal(false)">保存</el-button>
            <el-button @click="submitFormVal(true)">确认并提交</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { configUrl } from './resource/resource'
export default {
  name: 'fullWareReceipt',
  data() {
    return {
      // 客户
      customer: '',
      // 业务id与业务类型
      getType: {
        linkId: "",
        type: ''
      },
      // 柜号验证数字
      confirmWords: ['', '', '', ''],
      // 表单数据
      submitForm: {
        // 单号
        nos: {
          en: "",
          cn: ''
        },
        // 起运港
        departureEnPort: {
          en: "",
          cn: ''
        },
        // 目的港
        destinationEnPort: {
          en: "",
          cn: ''
        },
        // 件数
        piece: {
          en: "",
          cn: ''
        },
        // 柜号
        cntNo: {
          en: "",
          cn: ''
        },
        // 货值
        goodsValue: {
          en: "",
          cn: ''
        },
        // 提交人
        commit: {
          en: "",
          cn: ''
        },
        // 是否确认
        isConfirm: {
          en: "",
          cn: ''
        }
      },
      // 屏幕显示宽度
      windowWidth: window.innerWidth,
      // 中英文:CN:中文，EN:英文
      languageType: 'CN',
      // 入仓单当前预览序号
      previewIndex: 0,
      // 入仓单
      inOrderList: ['', '', '', '', '', ''],
      //移动端语言：CN:中文，EN：英文
      mobileLang: 'CN'
    }
  },
  computed: {
    deviceType() {
      if (this.windowWidth < 768) return 'mobile';
      if (this.windowWidth < 1024) return 'tablet';
      return 'desktop';
    },
    layoutClass() {
      return {
        'mobile-layout': this.deviceType === 'mobile',
        'tablet-layout': this.deviceType === 'tablet',
        'desktop-layout': this.deviceType === 'desktop'
      };
    }
  },
  mounted() {
    // 添加窗口大小变化监听
    window.addEventListener('resize', this.handleResize);
    this.initData()
  },
  beforeDestroy() {
    // 移除事件监听
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    /**
     * @param getBool: false:保存，true：确认并提交
     * */
    async submitFormVal(getBool) {
      if (this.confirmWords.join('').length != 4) {
        return this.$message.warning("请完整填写柜号")
      }
      if (!this.submitForm.goodsValue.en) {
        return this.$message.warning("请填写货值(USD)")
      }
      let params = {
        // 提交时间
        confirmTime: '',
        // 提交人
        confirmer: this.submitForm.commit.en,
        valueGoodsInformationDTO: [{
          // 是否确认    0未确认 1确认
          isConfirm: getBool ? 1 : 0,
          // 业务id
          linkid: this.getType.linkId,
          // 业务类型, 关联不同业务类型（整柜：C，工单：A
          type: this.getType.type,
          // 货值
          valueGoods: this.submitForm.goodsValue.en,
          // 柜号
          cntNo: this.submitForm.cntNo.en + this.confirmWords.join('')
        }]
      }
      let requestUrl = "/valueGoods/informationSave"
      const getRes = await this.axios.post(requestUrl, params
      )
      if (getRes.data.code == 200) {
        this.$message.success(getRes.data.message)
        this.initData()
      } else if (getRes.data.code == -1) {
        this.$message.warning(getRes.data.message)
      }

    },
    handleSonInput(val) {
      this.submitForm.commit.en = val
      this.submitForm.commit.cn = val
    },
    handleUsdInput(val) {
      if (typeof Number(val) === 'number' && Number(val) > 0) {
        this.submitForm.goodsValue.en = Number(val)
        this.submitForm.goodsValue.cn = Number(val)
      } else {
        this.submitForm.goodsValue.en = 0
        this.submitForm.goodsValue.cn = 0
      }

    },
    handleInput(value, index) {
      // 移除非数字字符，并截取第一位
      // value = value.match(/^./)?.[0] || '';
      this.$set(this.confirmWords, index, value.match(/^./)[0] || '')
    },
    // 保存
    saveForm() {
      // console.log(this.confirmWords)
    },
    // 初始化数据
    async initData() {
      let self = this

      let requestUrl = "/valueGoods/getCargoData/"
      // const urlParams = new URLSearchParams(window.location.search);
      // requestUrl += urlParams.get("customerId")
      const urlParams = this.$route.query.customerId
      requestUrl += urlParams
      const res = await this.axios.get(requestUrl
      )
      if (res.data.code == 200) {
        this.getType.linkId = res.data.data.linkId
        this.getType.type = res.data.data.type
        this.customer = res.data.data.customer
        for (let item in res.data.data.zh) {
          switch (item) {
            case 'departureZnPort':
              this.submitForm['departureEnPort']['cn'] = res.data.data.zh[item]
              break;
            case 'destinationZnPort':
              this.submitForm['destinationEnPort']['cn'] = res.data.data.zh[item]
              break;
            case 'cntNo':
              if (res.data.data.en.isConfirm != 1) {
                this.submitForm['cntNo']['cn'] = res.data.data.zh['cntNo'].substring(0, -4)
              } else {
                this.submitForm['cntNo']['cn'] = res.data.data.zh['cntNo']
              }
              break
            default:
              this.submitForm[item]['cn'] = res.data.data.zh[item]
              break;
          }

        }
        for (let item in res.data.data.en) {
          switch (item) {
            case 'departureEnPort':
              this.submitForm['departureEnPort']['en'] = res.data.data.en[item]
              break;
            case 'destinationEnPort':
              this.submitForm['destinationEnPort']['en'] = res.data.data.en[item]
              break;
            case 'cntNo':
              if (res.data.data.en.isConfirm != 1) {
                this.submitForm['cntNo']['en'] = res.data.data.en[item].slice(0, -4)
                this.submitForm['cntNo']['cn'] = res.data.data.en[item].slice(0, -4)
              } else {
                this.submitForm['cntNo']['en'] = res.data.data.en[item]
                this.submitForm['cntNo']['cn'] = res.data.data.en[item]
              }
              break
            default:
              this.submitForm[item]['en'] = res.data.data.en[item]
              break;
          }
        }
        console.log("this.submitForm", this.submitForm)
      }
    },
    //移动端切换语言
    changeMobileLang(val) {
      this.mobileLang = val
    },
    /**
     * 切换当前查看入仓单
     * @param previewIndex 入仓单序号
     * */
    changePreviewIndex(previewIndex) {
      this.previewIndex = previewIndex
      window.scrollTo({ top: this.previewIndex * 650, behavior: 'smooth' });
    },
    /**
     * 切换语言
     * @param val 
     * */
    changeLang(val) {
      this.languageType = val
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
    }
  }
}
</script>

<style>
#fullWareReceupt {
  box-sizing: border-box;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: fit-content;
  user-select: none;
}

.warehouse_PC {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: fit-content;
}

.warehouse_PC_con {
  position: relative;
  width: 50%;
  height: fit-content;
  min-width: 600px;
  background-color: #fff;
  border-radius: 10px;
}

.warehouse_PC_head {
  box-sizing: border-box;
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  font-weight: bold;
  color: #303133;
  border-bottom: 1px solid rgb(208, 208, 208);
  padding: 10px 0px;
}

.warehosue_PC_warning {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 20px;
  user-select: none;
  z-index: 9;
}

.warehouse_warning_chose {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.el-button {
  box-sizing: border-box;
  width: fit-content;
  height: 32px;
  line-height: 32px;
  margin: 0;
  padding: 0;
  padding: 0 12px;
}

.warehouse_warn_words {
  color: rgb(224, 0, 17);
  margin-top: 10px;
}

.warehouse_in_order {
  height: fit-content;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px;
  padding-bottom: 170px;
}

.warehouse_order_choices {
  width: 100%;
  position: sticky;
  top: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
  background-color: #fff;
  padding-bottom: 10px;
  z-index: 9;
  padding-top: 10px;
  /* box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1) */
}

.warehouse_choices_title {
  color: #606266;
  font-size: 18px;
  font-weight: 500;
  user-select: none;
}

.warehouse_choices_ul {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 20px;
  width: 100%;
  height: fit-content;
  padding-left: 20px;
}

.warehosue_choices_li {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border: 1px solid #e4e7ed;
  color: #606266;
  cursor: pointer;
  user-select: none;
}

.active_preview {
  background-color: #66b1ff;
  border-color: #66b1ff;
  color: #fff;
}

.warehouse_orders {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  height: fit-content;
  /* max-height: 800px; */
  /* border: 1px solid #F2F6FC; */
  margin-top: 20px;
  border-radius: 10px;
}

.warehouse_orders_item {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  height: fit-content;
  background-color: #fff;
  border-radius: 5px;
  padding: 10px;
  font-size: 18px;
  color: #606266;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.warehouse_item_title {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  height: 48px;
}

.warehouse_value_input {
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  color: rgb(224, 0, 17);
}

.warehouse_value_title {
  width: fit-content;
}

.warehouse_value_input .el-input {
  width: 200px;
  height: 32px !important;
}

.warehouse_value_input .el-input__inner {
  height: 32px;
  color: rgb(224, 0, 17);
}

.warehouse_con_son .el-input__inner {
  height: 32px;
  color: rgb(224, 0, 17);
  border: none;
}

.warehouse_con_son .el-input__inner::placeholder {
  color: rgb(224, 0, 17);
}

.warehouse_orders_con {
  width: 100%;
  height: 520px;
  display: grid;
  grid-template-columns: repeat(10, 1fr);
  grid-template-rows: repeat(7, 1fr);
  border: 1px solid #909399;
  /* padding-bottom: 100px; */
}

.warehouse_con_son {
  border: 1px solid #909399;
  border-top: none;
  border-left: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-left: 10px;
}

.warehouse_con_son:nth-child(1) {
  grid-row: 1/2;
  grid-column: 1/3;
}

.warehouse_con_son:nth-child(2) {
  grid-row: 1/2;
  grid-column: 3/11;
  border-right: none;
}

.warehouse_con_son:nth-child(3) {
  grid-row: 2/3;
  grid-column: 1/3;
}

.warehouse_con_son:nth-child(4) {
  grid-row: 2/3;
  grid-column: 3/11;
  border-right: none;
}

.warehouse_con_son:nth-child(5) {
  grid-row: 3/4;
  grid-column: 1/3;
}

.warehouse_con_son:nth-child(6) {
  grid-row: 3/4;
  grid-column: 3/11;
  border-right: none;
}

.warehouse_con_son:nth-child(7) {
  grid-row: 4/5;
  grid-column: 1/3;
}

.warehouse_con_son:nth-child(8) {
  grid-row: 4/5;
  grid-column: 3/11;
  border-right: none;
}

.warehouse_con_son:nth-child(9) {
  grid-row: 5/6;
  grid-column: 1/3;
}

.warehouse_con_son:nth-child(10) {
  grid-row: 5/6;
  grid-column: 3/11;
  border-right: none;
}

.warehouse_con_son:nth-child(11) {
  grid-row: 6/7;
  grid-column: 1/3;
}

.warehouse_con_son:nth-child(12) {
  grid-row: 6/7;
  grid-column: 3/11;
  border-right: none;
}

.warehouse_con_son:nth-child(13) {
  grid-row: 7/8;
  grid-column: 1/3;
  border-bottom: none;
}

.warehouse_con_son:nth-child(14) {
  grid-row: 7/8;
  grid-column: 3/11;
  border-bottom: none;
  border-right: none;
}

.warehouse_PC_bottom {
  position: fixed;
  left: 50%;
  bottom: 0px;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  width: 50%;
  height: 100px;
  background-color: #fff;
}

.warehouse_PC_bottom .el-input {
  width: 200px;
  height: 32px !important;
}

.warehouse_PC_bottom .el-input__inner {
  height: 32px;
  color: rgb(224, 0, 17);
}

.warehouse_bottom_first {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  height: 60px;
  padding-right: 20px;
}

.warehouse_bottom_second {
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 30px;
  border-top: 1px solid #909399;
  padding-top: 20px;
}

.warehouse_bottom_second .el-button {
  height: 40px;
  padding: 0 20px;
  font-size: 17px;
  font-weight: 500;
  border-radius: 10px;
}

.warehouse_bottom_second .el-button:first-child {
  border: 1px solid #409eff;
  color: #409eff;
}

.warehouse_bottom_second .el-button:last-child {
  background-color: #409eff;
  color: #fff;
}

.warehouse_Mobile {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: fit-content;
  padding-bottom: 130px;
}

.warehouse_Mobile_title {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-end;
  width: 100%;
  height: 80px;
  background-color: rgb(57, 192, 87);
  padding-bottom: 20px;
  color: #fff;
  font-size: 18px;
}

.warehouse_Mobile_warning {
  box-sizing: border-box;
  width: 100%;
  padding: 10px 10px;
  color: #ee3330;
  background-color: #ffeeef;
  font-size: 14px;
  font-weight: bold;
}

.warehouse_Mobile_con {
  box-sizing: border-box;
  width: 100%;
  height: fit-content;
  padding: 10px;
  /* background-color: red; */
}

.warehouse_Mobile_lang {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  padding-left: 10px;
  color: #606266;
  width: 100%;
  height: 60px;
  background-color: #fff;
  border-radius: 10px;
}

.Mobile_chose_btn {
  box-sizing: border-box;
  width: fit-content;
  height: 32px;
  padding: 0 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border: 1px solid #e4e7ed;
  border-radius: 20px;
}

.Mobile_btn_active {
  border-color: #39c057;
  color: #39c057;
}

.warehouse_inOrder_list {
  box-sizing: border-box;
  width: 100%;
  height: fit-content;
  background-color: #f9f9f9;
  margin-top: 10px;
}

.warehouse_inOrder_ul {
  box-sizing: border-box;
  width: 100%;
  height: fit-content;
  padding: 10px;
  list-style: none;
  background-color: #fff;
  border-radius: 5px;
}

.warehouse_inOrder_li {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  height: fit-content;
  margin-top: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  padding: 10px;
  border-radius: 5px;
}
.warehouse_inOrder_li:first-child {
  margin-top: 0px;
}

.inOrder_li_cus {
  border-left: 4px solid #39c057;
  padding-left: 5px;
  color: #303133;
  font-weight: 500;
}

.inOrder_li_money {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  color: rgb(224, 0, 17);
}

.inOrder_li_money .el-input {
  width: 200px;
  height: 32px !important;
}

.inOrder_li_money .el-input__inner {
  height: 32px;
  color: rgb(224, 0, 17);
}

.inOrder_li_form {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: fit-content;
  background-color: #f9f9f9;
  padding: 10px;
  padding-top: 0px;
}

.inOrder_li_form > div {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 48px;
  border-bottom: 1px solid #ebeef5;
}

.inOrder_li_form > div > div:first-child {
  flex: 2;
  color: #606266;
}

.inOrder_li_form > div > div:last-child {
  flex: 5;
  color: #303133;
  font-weight: 500;
}

.mobile_submit_bottom {
  position: fixed;
  left: 0px;
  bottom: 0px;
  width: 100%;
  height: 120px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  background-color: #fff;
}

.mobile_submit_man {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 50px;
  border-bottom: 1px solid #ebeef5;
}

.mobile_submit_contact {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100px;
  color: #606266;
  font-size: 16px;
  font-weight: 500;
}

.mobile_submit_man .el-input__inner {
  width: 100%;
  height: 32px;
  border: none;
}

.mobile_submit_btns {
  box-sizing: border-box;
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 0 10px;
}

.mobile_submit_btns .el-button {
  box-sizing: border-box;
  height: 42px;
  border-radius: 20px;
  font-size: 18px;
  font-weight: 500;
}

.mobile_submit_btns .el-button:first-child {
  flex: 3;
  color: #39c057;
  border: 1px solid #39c057;
}

.mobile_submit_btns .el-button:last-child {
  flex: 5;
  background-color: #39c057;
  color: #fff;
}

.input_num {
  width: 40px;
  height: 40px;
  border: 1px solid rgb(224, 0, 17);
  border-radius: 5px;
  outline: none;
  line-height: 40px;
  color: rgb(224, 0, 17);
  font-size: 22px;
  /* padding: 0px; */
  /* padding-left: 10px; */
  /* padding-left: 15px; */
}

.input_num .el-input__inner {
  padding: 0px;
  padding-left: 10px;
}

.boxNum .input_num {
  width: 30px;
  height: 30px;
  border: none;
  border-radius: 5px;
  outline: none;
  line-height: 30px;
  color: transparent;
  font-size: 22px;
  /* padding: 0px; */
  /* padding-left: 10px; */
  /* padding-left: 15px; */
}

.boxNum .input_num .el-input__inner {
  padding: 0px;
  padding-left: 10px;
  background-color: #f2f2f2;
}

.boxNum .el-input__inner {
  width: 30px;
  height: 30px;
  line-height: 30px;
  border: none;
}

.mobile_money .el-input__inner {
  color: rgb(224, 0, 17);
}

.mobile_money .el-input__inner::placeholder {
  color: rgb(224, 0, 17);
}
</style>


// WEBPACK FOOTER //
// src/components/goodsValue/fullWareReceipt.vue